import gql from "graphql-tag";
import UserFragment from "src/hoc/fragments/user.fragment";
import { IUser } from "src/types/user";

export interface IUserNewsletterSubscribeVar {
  input: { subscribedToNewsletter: boolean };
}

export interface IUserNewsletterSubscribeRes {
  userNewsletterSubscribe: IUser | null;
}

export const UserNewsletterSubscribeMutation = gql`
  mutation($input: NewsletterSubscribeInput) {
    userNewsletterSubscribe(input: $input) {
      ...UserFragment
    }
  }
  ${UserFragment}
`;
